module.exports = __webpack_public_path__ + "static/media/watermark-dark-evolutive-background.f5399343.svg";